import { render, staticRenderFns } from "./vip-home-free.vue?vue&type=template&id=eb1cfedc&scoped=true&"
import script from "./vip-home-free.vue?vue&type=script&lang=js&"
export * from "./vip-home-free.vue?vue&type=script&lang=js&"
import style0 from "./vip-home-free.vue?vue&type=style&index=0&id=eb1cfedc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1cfedc",
  null
  
)

export default component.exports